import React from 'react';
import './ExplorerLessonPlanIcon.less';

interface Props {
  className: string;
}
export const ExplorerLessonPlanIcon: React.FC<Props> = ({ className = '' }) => (
  <div className={`explorer-lesson-plan-icon ${className}`} />
);
